<template>
    <div id="SpecialDetail">
        <nav-bar>
            <div slot="left">
                <van-icon name="arrow-left" color="#666666" size="20" @click="goBack"/>
            </div>
            <div slot="title">
                专题详情
            </div>
            <div slot="right">
                <img src="@/assets/image/icon/share.png" @click.stop="shareGoods">
<!--                <img src="@/assets/image/icon/col.png" @click.stop="colGoods">-->
            </div>
        </nav-bar>
        <div style="margin-top: 46px;">
            <van-swipe class="my-swipe" autoplay="0" height="250">
                <van-swipe-item v-for="(item, index) in swipeImages" :key="index">
                    <van-image :src="item" height="250" />
                </van-swipe-item>
            </van-swipe>
            <div style="padding: 0 10px">
                <p class="special-title">仙风锦鲤杯的诞生</p>
                <div>
                    <van-image round src="https://img.yzcdn.cn/vant/cat.jpeg" width="40" height="40"></van-image>
                    <div class="special-name">餐厨专题</div>
                    <div class="special-time">2020-03-22 11:05</div>
                </div>
                <div class="special-content">
                    <p>去年夏天，品牌中心的设计师路过园区里水池的时候，和同事玩笑道：“这儿就是少了几条锦鲤。”商品组灵机一动，是不是可以把传说中“转发就能带来好运气“的锦鲤做成杯子，留在手边，也许好运气也可以一直伴随着大家。</p>
                    <p>既然要做古风系列，她还从传统文化中选择了仙鹤的形象，分别设计了两款不同容量的杯子。身姿优美的仙鹤配上纸伞，从水中跃出的鲤鱼，都是她一笔一画绘制、调色。不得不说设计师们的职业病真是太严重了，本来是要做适合夏天用的双层杯的，改稿子、反复打样实在太多次，不是质感不够好就是颜色和握感跟最初的设计有出入。这款杯子的定样从夏天反复打磨到了春天，这才有了现在这款商品呈现在大家面前的样子。</p>
                    <p>虽然它的诞生过程很坎坷，最终还是带着同事们的美好祝愿上线了。我们希望寓意着“一辈子”的“一杯子”能够被大家喜爱。漂亮的礼盒包装不管是自用还是送人都很合适。</p>
                </div>
            </div>
        </div>
        <div>
            <van-divider
                    :style="{ color: 'rgb(102, 152, 203)', borderColor: 'rgb(102, 152, 203)', padding: '0 16px' }"
            >
                相关单品
            </van-divider>
            <van-card
                    price="2.00"
                    desc="描述信息"
                    title="商品标题"
                    thumb="https://img.yzcdn.cn/vant/ipad.jpeg"
                    @click="toGoodsInfo(1)"
            >
                <template #footer>
<!--                    <img src="@/assets/image/icon/col.png" @click.stop="colGoods">-->
                    <img src="@/assets/image/icon/shopping_cart.png" @click.stop="showCart" style="margin-left: 10px">
                </template>
            </van-card>
            <van-card
                    price="2.00"
                    desc="描述信息"
                    title="商品标题"
                    thumb="https://img.yzcdn.cn/vant/ipad.jpeg"
                    @click="toGoodsInfo(1)"
            >
                <template #footer>
<!--                    <img src="@/assets/image/icon/col.png" @click.stop="colGoods">-->
                    <img src="@/assets/image/icon/shopping_cart.png" @click.stop="showCart" style="margin-left: 10px">
                </template>
            </van-card>
            <van-card
                    price="2.00"
                    desc="描述信息"
                    title="商品标题"
                    thumb="https://img.yzcdn.cn/vant/ipad.jpeg"
                    @click="toGoodsInfo(1)"
            >
                <template #footer>
<!--                    <img src="@/assets/image/icon/col.png" @click.stop="colGoods">-->
                    <img src="@/assets/image/icon/shopping_cart.png" @click.stop="showCart" style="margin-left: 10px">
                </template>
            </van-card>
        </div>
    </div>
</template>

<script>
    import { Icon, Toast, Image, Divider, Card, Button, Swipe, SwipeItem } from 'vant';
    import NavBar from "../../components/common/navbar/NavBar";
    export default {
        name: "SpecialDetail",
        components: {
            NavBar: NavBar,
            [Icon.name]: Icon,
            [Toast.name]: Toast,
            [Image.name]: Image,
            [Divider.name]: Divider,
            [Card.name]: Card,
            [Button.name]: Button,
            [Swipe.name]: Swipe,
            [SwipeItem.name]: SwipeItem
        },
        data() {
            return {
                isColGoods: false,
                swipeImages: [
                    'https://img.yzcdn.cn/vant/cat.jpeg',
                    'https://img.yzcdn.cn/vant/apple-2.jpg',
                    'https://img.yzcdn.cn/vant/cat.jpeg'
                ],
            }
        },
        methods: {
            goBack() {
                this.$router.back(-1)
            },
            shareGoods() {
                Toast('分享')
            },
            colGoods() {
                this.isColGoods = this.isColGoods ? false : true;
                Toast('收藏')
            },
            showCart() {
                this.$router.push({path: '/order/shoppingCart'})
            },
            toGoodsInfo(id) {
                this.$router.push({path: '/goods/goodsInfo/' + id})
            }
        }
    }
</script>

<style scoped>
    @import "~@/assets/css/index/style.css";

    .van-nav-bar {
        box-shadow: 0px 1px 3px 0px rgba(0,0,0,.5);
        background-color: #efefef;
    }

    .special-title {
        color: #666666;
        font-size: 16px;
    }
    .special-name {
        float: left;
        line-height: 40px;
        margin-left: 15px;
        color: #666666;
    }

    .special-time {
        float: right;
        line-height: 40px;
        margin-left: 15px;
        color: #666666;
    }

    .van-image {
        float: left;
    }

    .special-content {
        color: #666666;
        padding-top: 43px;
        line-height: 20px;
    }

    .van-card {
        border-bottom: 1px solid #ccc;
        margin-top: 0;
        background-color: #eee;
    }

</style>